import { IDataDefinition } from "../Data/Definitions/IDataDefinition";
import { DataDefinition } from "../Data/DataDefinition";
import { ExecutionData } from "../Data/ExecutionData/ExecutionData";
import { IConfigStorage } from "../IConfigStorage";
import { ITestingContext } from "../Testing/ITestingContext";
import { ExecutableReturnPromise } from "./ExecutableReturnPromise";
import { DataUtilities } from "../DataUtilities";

export class MultiExecutableOutputDefinition implements IConfigStorage {
    name: string;
    dataOutput: IDataDefinition[];

    constructor(name: string = "done", dataOutput: IDataDefinition[] = []) {
        this.name = name;
        this.dataOutput = dataOutput;
    }

    getStorageData(): object {
        let data = {};
        Reflect.set(data, "name", this.name);

        Reflect.set(data, "outputs", DataUtilities.getDataDefinitionDataFromDefinitionList(this.dataOutput));

        return data;
    }

    setStorageData(data: object): void {
        this.name = Reflect.get(data, "name");

        this.dataOutput = DataUtilities.getDataDefinitionListFromData(Reflect.get(data, "outputs"));
    }
}

export abstract class MultiExecutable implements IConfigStorage {
    inputData?: DataDefinition | (() => DataDefinition);

    get canChangeInputs(): boolean {
        return !this.inputData || !(this.inputData instanceof Function);
    }

    getInputDefinition(): DataDefinition {
        if (!this.inputData) {
            this.inputData = new DataDefinition();
            return this.inputData;
        }

        if (this.inputData instanceof Function) {
            return this.inputData();
        } else {
            return this.inputData;
        }
    }

    getStorageData(): object {
        let data = {};

        if (this.inputData && !(this.inputData instanceof Function)) {
            Reflect.set(data, "inputData", this.getInputDefinition().getStorageData());
        }

        return data;
    }

    setStorageData(data: object): void {
        let idata = Reflect.get(data, "inputData");

        if (idata) {
            this.inputData = new DataDefinition();
            this.inputData.setStorageData(idata);
        }
    }

    abstract run(data: ExecutionData, testContext: ITestingContext | undefined): ExecutableReturnPromise;

    abstract getOutcomes(): MultiExecutableOutputDefinition[];
}
